/* eslint-disable multiline-ternary */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useMemo, useState } from 'react';
import { Box, Grid, Typography, Menu, MenuItem, Avatar } from '@mui/material';
import { catchErr, DateDiff, Formatter, userFullName } from '../../../../../../../libs/HelperContent';
import { LanguageContext } from '../../../../../../../libs/Context';
import { MdOutlineMoreHoriz } from 'react-icons/md';
import { GoThumbsup } from 'react-icons/go';
import { HiThumbUp } from 'react-icons/hi';
import NewDialogPopup from '../../../../../../../components/Common/NewDialogPopup/NewDialogPopup';
import { deleteCommentApi, updateCmntAction, updateEventLikes } from '../../../../../../actions/feeds_actions_new';
import { useSelector } from 'react-redux';
import { deleteEventComment } from '../../../../../../actions/recognition_actions';
import AvatarListPopup from '../../../../../../../components/Common/AvatarListPopup';
import { feedActionContext } from '../../../../..';
import { feedActionContextFromExternal } from '../../../../ExternalRequest';
import ProfilePic from '../../../../../../../components/Common/ProfilePic';
import useFeedApproval from '../../../../LeftPart/FeedCreation/CustomHooks/useFeedApproval';

const Replies = (props) =>
{
	const { reply, setRepliesData, handleCmntUpdat, setAction, repliesData, from, selEvent } = props;
	const [ showMore, setShowMore ] = useState(false);
	const { language } = useContext(LanguageContext);
	const [ anchorEl, setAnchorEl ] = useState(null);
	const openMenu = Boolean(anchorEl);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const [ replyActn, setReplyActn ] = useState<any>({});
	const [ likePop, setLikePop ] = useState(false);

	const shouldShowMore = reply?.comment?.length > 35;
	const displayedComment = showMore ? reply?.comment : `${reply?.comment?.substring(0, 35)}`;
	const { feedCardActn } = useContext(window.location.pathname.includes('news') ? feedActionContext : feedActionContextFromExternal);

	const currentUser = useSelector((state:any) => state?.mysession?.userConfigs);
	const { isFeedsAdmin } = useFeedApproval();

	const canHide = useMemo(() =>
	{
		if (currentUser?.companyId === feedCardActn[1]?.createdBy)
		{
			return isFeedsAdmin;
		}
		else if (feedCardActn[1]?.createdBy === currentUser.userId)
		{
			return true;
		}

		return false;
	}, [
		currentUser.companyId,
		currentUser?.feedManagement,
		currentUser.userId,
		feedCardActn,
		isFeedsAdmin
	]);

	const handleClick = (event) =>
	{
		setAnchorEl(event.currentTarget);
	};

	// Generate body for update likes and hide comments
	const generateBody = (type, data) =>
	{
		let body;

		if (type === 'updateLike')
		{
			body = {
				like      : !data?.selfLike,
				commentId : reply?._id,
				...(from === 'events'
					? { eventId: selEvent?.eventId }
					: { userData: { userId: userData?.userId, firstName: userFullName(userData) } })
			};
		}
		else
		{
			body = {
				hide      : !data?.hideComment,
				commentId : reply?._id
			};
		}

		return body;
	};
	// Update likes, hide and delete comments
	const handleUpdateReply = async (type, data) =>
	{
		try
		{
			const body = generateBody(type, data);

			const res = from === 'events'
				? await updateEventLikes(body) // Update likes for events
				: await updateCmntAction(body); // Update likes for feeds

			if (res?.status)
			{
				if (type === 'updateLike')
				{
					const updteIndex = repliesData?.findIndex((itemD) => itemD._id === data?._id);

					if (updteIndex === -1) return; // Ensure valid index

					const updatedViewData = [ ...repliesData ];
					const likeCount = updatedViewData[updteIndex]?.[from === 'feeds' ? 'likesCount' : 'likeCount'] || 0;

					updatedViewData[updteIndex] = {
						...updatedViewData[updteIndex],
						likesCount : from === 'feeds'
							? body?.like ? likeCount + 1 : likeCount - 1
							: updatedViewData[updteIndex]?.likesCount,

						likeCount : from === 'events'
							? body?.like ? likeCount + 1 : likeCount - 1
							: updatedViewData[updteIndex]?.likeCount,

						selfLike : body?.like
					};

					setRepliesData(updatedViewData);
				}
				else if (type === 'updateHide')
				{
					const updatedData = {
						...data,
						hideComment : !data?.hideComment
					};

					setRepliesData((prevData) =>
						prevData.map((comment) =>
							(comment._id === data._id ? updatedData : comment)
						)
					);
				}
				else
				{
					const dataD = repliesData?.filter((itemD) => itemD?._id !== data?._id);

					setRepliesData(dataD);
				}
			}
			else
			{
				setRepliesData(repliesData);
			}
		}
		catch (err)
		{
			console.log(err);
			catchErr(err);
		}
	};
	// Delete comments
	const deleteComment = async () =>
	{
		try
		{
			const query:any = {
				uid     : userData?.userId,
				comid   : userData?.companyId,
				empRole : userData?.empRole,
				role    : userData?.role

			};
			const path = from === 'events' ? replyActn?.commentId : replyActn?._id;
			const res = from === 'events'
				? await deleteEventComment(path, query)
				: await deleteCommentApi(path, query);

			if (res?.status)
			{
				const updatedRepliesData = repliesData?.filter((item) => item?._id !== replyActn?._id);

				setRepliesData(updatedRepliesData);
			}
			else
			{
				setRepliesData(repliesData);
			}
		}
		catch (err)
		{
			console.log(err);
			catchErr(err);
		}
		finally
		{
			setReplyActn({});
		}
	};
	const isGif = (url) =>
	{
		return /\.(gif)$/i.test(url);
	};

	const handleError = (event: any) =>
	{
		event.currentTarget.src = '/images/icons/defaultUser.svg';
	};

	const checkFromEventsOrFeed = (from === 'events' ? reply?.userId : reply?.createdBy) === userData?.userId;

	// Check if the current user is the owner of the comment
	const isCurrentUser = from === 'events'
		? reply?.userId === userData?.userId
		: reply?.userData?.userId === userData?.userId;

	return (
		<>
			<Grid item container key={reply?._id} pl={4} pt='var(--pixel16)' pb={0.5}>
				<Grid item borderLeft='1px dashed #E6E4EA' pl='var(--pixel8)'>
					{/* <Avatar sx={{ width: 32, height: 32, border: '1px solid #E6E4EA' }}
						onError={handleError}
						src={`${process.env.REACT_APP_S3_BASE_URL}/profile/${reply?.userData?.userId || reply?.userId}_profile.jpeg?t=${new Date().valueOf()}`}
					/> */}
					<Box display='inline-flex'
						height={32}
						width={32}
						alignItems='center'
						justifyContent='center'
					>

						<ProfilePic
							imagePath={`${reply?.userData?.userId}.jpeg`}
							defaultImg='/images/icons/defaultUser.svg'
							// loadUrl='profile'
							alt='createdBy_img'
							className='brdrRadius50'
							from='selfProfile'
						/>
					</Box>
				</Grid>
				<Grid item xs spacing={0.5} px='var(--pixel8)'>
					<Box sx={{ minWidth: 0, overflow: 'hidden' }}>

						<Box sx={{ minWidth: 0, overflow: 'hidden', display: 'flex' }} alignItems='center' justifyContent='space-between'>
							<Box display='flex'>
								<Typography variant='inherit' component='span' fontWeight='var(--font500)'
									sx={{
										whiteSpace   : 'nowrap',
										overflow     : 'hidden',
										textOverflow : 'ellipsis'
									}}
								>
									{isCurrentUser ? 'You' : reply?.userData?.firstName}
								</Typography>
								<Typography variant='caption' component='span' pl={0.9} color='#536471' sx={{ display: 'flex', flex: 'none' }}>
									{DateDiff(reply?.updatedAt, new Date()?.valueOf())}
								</Typography>
							</Box>
							<Grid item display='flex' justifyContent='flex-end'>
								<MdOutlineMoreHoriz fontSize='var(--pixel24)' color='#536471' onClick={handleClick} style={{ cursor: 'pointer' }}/>
							</Grid>
						</Box>
						{reply.hideComment === true ? <Typography variant='caption' sx={{ color: 'gray', fontStyle: 'italic' }}>
							{language.commentHidden}
						</Typography> : <><Typography variant='caption' sx={{ p: 1 }} >
							{isGif(reply?.comment)
								? (
									<Box sx={{ p: 1 }}>
										<img
											src={reply?.comment}
											alt='GIF'
											style={{ maxWidth: 'var(--percent100)', height: 'auto' }}
										/>
									</Box>
								)
								: <>
									<Typography variant='body2' component='span' sx={{ wordBreak: 'break-all' }} >
										{displayedComment}
									</Typography>
									{shouldShowMore && (
										<Typography
											variant='caption'
											component='span'
											onClick={() => setShowMore((prev) => !prev)}
											pl='var(--pixel4)'
											color='var(--primaryColor)'
											sx={{ cursor: 'pointer' }}
										>
											{showMore ? language.less : language.more}
										</Typography>
									)}
								</>}
						</Typography><Grid container direction='row' spacing={0.5} alignItems='center'>
							<Grid item onClick={() => handleUpdateReply('updateLike', reply)}
								sx={{
									cursor        : 'pointer',
									display       : 'flex',
									alignItems    : 'center',
									color         : '#536471',
									'&:hover svg' : {
										backgroundColor : 'transparent',

										color     : '#23A4C4', // Hover color
										transform : 'scale(1.2)' // Hover scale
									}
								}}
							>
								{reply?.selfLike ? <HiThumbUp fontSize='var(--pixel18)' color='var(--primaryColor)' /> : <GoThumbsup fontSize='var(--pixel18)' />}
							</Grid>

							<Grid item sx={{ display: 'flex', alignItems: 'center' }} onClick={() => setLikePop(true)}>
								<Typography variant='caption' color='#536471'>
									<span className='pointer'>
										{Formatter((from === 'events' ? reply?.likeCount : reply?.likesCount) || 0)}
									</span> &nbsp;
									{(from === 'events' ? reply?.likeCount : reply?.likesCount) > 1 ? `${language?.likes}` : `${language?.like}`}
								</Typography>
							</Grid>
							<Grid item sx={{ display: 'flex', alignItems: 'center' }}>
								<Typography
									variant='caption'
									color='#536471'
									onClick={() => setAction({ cmntReply: reply })}
									sx={{
										cursor      : 'pointer',
										position    : 'relative',
										paddingLeft : 'var(--pixel8)',
										'&::before' : {
											content         : '""',
											position        : 'absolute',
											left            : 0,
											top             : '2px',
											height          : '78%',
											width           : '1px',
											backgroundColor : 'rgba(83, 100, 113, 0.5)'
										}
									}}
								>
									{language?.reply}
								</Typography>
							</Grid>
						</Grid></>}

					</Box>
				</Grid>
			</Grid>
			{checkFromEventsOrFeed || canHide ? (
				<Menu
					id='basic-menu'
					anchorEl={anchorEl}
					open={openMenu}
					onClose={() => setAnchorEl(null)}
					sx={{ marginLeft: '-6px' }}
					anchorOrigin={{
						vertical   : 'bottom',
						horizontal : 'left'
					}}
					transformOrigin={{
						vertical   : 'top',
						horizontal : 'left'
					}}
				>
					{!isGif(reply?.comment) && checkFromEventsOrFeed &&
					<MenuItem onClick={() =>
					{
						setAction({ cmntEdit: reply });
						handleCmntUpdat(reply?.comment);
						setAnchorEl(null);
					}}
					>
						{language?.edit}
					</MenuItem>}
					{checkFromEventsOrFeed
						? <MenuItem onClick={() => { setReplyActn(reply); setAnchorEl(null); }}>
							{language?.delete}</MenuItem>
						:					<MenuItem onClick={() => { handleUpdateReply('updateHide', reply); setAnchorEl(null); }}>
							{reply?.hideComment === true ? 'Unhide' : language?.hide}
						</MenuItem>
					}
				</Menu>) : null }
			{Object?.keys(replyActn)?.length > 0 &&
			<NewDialogPopup
				open={Boolean(Object?.keys(replyActn)?.length > 0)}
				closeCallBack={deleteComment}
				handleConfirm={() => setReplyActn({})}
				type='no'
				id={undefined}
				label={language.deleteCommentWarning}
				from='feedCreate'
				formatType='yes'
			/>
			}
			{likePop &&
			<AvatarListPopup
				attendees={likePop}
				title={language.likes}
				handleAttendeesClose={() => setLikePop(false)}
				requestType='comment'
				requestId={reply?._id}
			/>
			}
		</>
	);
};

export default Replies;